<script setup lang="ts">
/**
 * Presentational stat cluster: a horizontal grid of value-over-label cells (auto-sized columns,
 * tabular-nums values). The canonical "distance / ascent / descent" headline shape. Domain
 * components (e.g. RouteStatsRow) compute the numbers and pass them in; this only renders.
 *
 * `label` is optional per cell (values-only clusters). `grade` renders as a small subscript next to
 * the value. Single-root grid so data-testid / extra classes fall through.
 *
 * Intentionally NOT a catch-all: the icon-led tour header, dense library rows and the nav HUD are
 * distinct presentations and keep their own markup.
 */
export interface StatItem {
  key: string
  value: string
  label?: string
  grade?: string | null
}
interface Props {
  stats: StatItem[]
}
defineProps<Props>()
</script>

<template>
  <div class="grid auto-cols-fr grid-flow-col gap-x-3">
    <div v-for="stat in stats" :key="stat.key" class="flex min-w-0 flex-col leading-tight">
      <span class="truncate text-sm font-semibold tabular-nums text-neutral-900">
        {{ stat.value
        }}<span v-if="stat.grade" class="ml-0.5 text-[10px] font-medium text-neutral-500">{{
          stat.grade
        }}</span>
      </span>
      <span v-if="stat.label" class="text-[11px] uppercase tracking-wide text-neutral-600">{{
        stat.label
      }}</span>
    </div>
  </div>
</template>
